// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2opsO","colMin":"styles_colMin__3-uef","colCheckbox":"styles_colCheckbox__14-DT"};